import React from "react";

export const CallforPapers = () => {
  return (
      <div className="visa-big-box container">
        <h5>
          The International Conference on Intelligent Human-Computer Interaction
          (IHCI) 2023 invites researchers, practitioners, and professionals from
          the field of Human-Computer Interaction to submit their original
          research papers. IHCI is a prestigious conference that provides a
          platform for the exchange of ideas, knowledge, and advancements in the
          interdisciplinary field of HCI. Here are the details and guidelines
          for paper submissions
        </h5>

        <h4>1. Topics of Interest</h4>
        <h5 className="information">
          We welcome papers on various topics related to Human-Computer
          Interaction, including but not limited to:
        </h5>
        <ul>
          <li>User experience design and evaluation</li>
          <li>Interaction techniques and interfaces</li>
          <li>Usability and accessibility</li>
          <li>User-centered design and innovation</li>
          <li>Cognitive and affective aspects of interaction</li>
          <li>Social computing and collaborative interfaces</li>
          <li>Augmented and virtual reality experiences</li>
          <li>Wearable computing and ubiquitous interactions</li>
          <li>Multimodal interfaces and natural language processing</li>
          <li>Human-robot interaction and intelligent interfaces</li>
          <li>
            HCI in specific domains (e.g., healthcare, education, entertainment)
          </li>
        </ul>

        <h4>2. Paper Categories</h4>
        <h5 className="information">
          Authors can submit their papers under the following categories:
        </h5>
        <ul>
          <li>
            Full Research Papers: Original research contributions with novel
            methodologies, findings, and implications [10-12 pages]
          </li>
          <li>
            Short Papers: Concise research papers, work-in-progress, or
            preliminary results.[ 4-6 pages]
          </li>
          <li>
            Case Studies and Applications: Papers showcasing real-world
            applications of HCI principles and technologies.[ 4-6 pages]
          </li>
          <li>
            Industry Papers: Papers highlighting industry perspectives,
            challenges, and innovations in HCI. [4-6 pages].
          </li>
        </ul>

        <h4>3. Submission Guidelines</h4>
        <h5 className="information">
          Authors should adhere to the following guidelines for paper
          submissions:
        </h5>
        <ul>
          <li>
              Paper Length: Full research papers should be between 8 to 10
              pages, while short papers should be between 4 to 6 pages. Case
              studies and industry papers should be between 6 to 8 pages.
          </li>
          <li>
              Formatting: Papers should follow the conference's specified
              formatting guidelines (Springer LNCS templates).
          </li>
          <li>Language: All papers must be written in English.
          </li>
        </ul>

        <h4>4. Review Process:</h4>
        <h5 className="information">
          All submitted papers will undergo a rigorous double-blind peer review
          process by an expert panel of reviewers. Submissions will be evaluated
          based on their originality, significance, technical quality, and
          clarity of presentation.
        </h5>

        <h4>5. Publication:</h4>
        <h5 className="information">
          Accepted papers will be included in the conference proceedings, which
          will be published in digital format in Lecture Notes on Computer
          Science (LNCS) by Springer and made available to conference attendees.
          The proceedings will be indexed in Scopus, Google Scholar, DBLP, ACM
          Digital Library, and other relevant databases. Additionally, selected
          papers may be considered for publication in relevant journals or
          special issues.
        </h5>

        <h4>6. Submission Portal</h4>
        <h5 className="information">
          Authors should submit their papers electronically through the
          designated submission portal on the conference website.
        </h5>

        <h4>7. Important Dates</h4>
        <ul>
          <li>Paper Submission Deadline: August 15, 2023
          </li>
          <li>
            Notification of Acceptance: September 15, 2023
          </li>
          <li>
            Camera-Ready Paper Submission: September 25, 2023
          </li>
        </ul>

        <h5>
          We encourage researchers, practitioners, and professionals to submit
          their high-quality papers to IHCI 2023 and contribute to the
          advancement of the field of Human-Computer Interaction. We look
          forward to your submissions and the opportunity to engage in fruitful
          discussions at the conference.
        </h5>
        <hr className="hr-style" />
      </div>
  );
};
